import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocationDTO, LocationOnlineStatus } from 'src/app/services/api/api';

@Component({
  selector: '[sb-comp-location-online-status]',
  templateUrl: './sb-location-online-status.component.html',
  styleUrls: ['./sb-location-online-status.component.scss'],
  standalone: false,
})
export class SbLocationOnlineStatusComponent implements OnInit {
  @Input() location: LocationDTO;

  tooltip: string;
  faIcon: string;
  color: string;
  text: string;

  constructor(public translate: TranslateService) {
    this.tooltip = '';
    this.faIcon = '';
    this.color = '';
    this.text = '';
  }

  ngOnInit(): void {
    this.initFields();
    this.translate.onDefaultLangChange.subscribe(() => {
      this.initFields();
    });
  }

  iconText() {
    switch (this.location.onlineStatus) {
      case LocationOnlineStatus.Unknown:
        return '???';
      case LocationOnlineStatus.AllOnline:
        return this.translate.instant('lang.globals.online');
      case LocationOnlineStatus.Online:
        return this.translate.instant('lang.globals.online');
      case LocationOnlineStatus.MostlyOnline:
        return this.translate.instant('lang.globals.mixed');
      case LocationOnlineStatus.AllCurrentlyOffline:
        return this.translate.instant('lang.globals.mixed');
      case LocationOnlineStatus.MostlyOffline:
        return this.translate.instant('lang.globals.mixed');
      case LocationOnlineStatus.Offline:
        return this.translate.instant('lang.globals.offline');
      case LocationOnlineStatus.AllOffline:
        return this.translate.instant('lang.globals.offline');
      default:
        return '???????';
    }
  }

  iconColor() {
    switch (this.location.onlineStatus) {
      case LocationOnlineStatus.Unknown:
        return 'grey';
      case LocationOnlineStatus.AllOnline:
        return 'green';
      case LocationOnlineStatus.Online:
        return 'green';
      case LocationOnlineStatus.MostlyOnline:
        return 'yellow';
      case LocationOnlineStatus.AllCurrentlyOffline:
        return 'yellow';
      case LocationOnlineStatus.MostlyOffline:
        return 'yellow';
      case LocationOnlineStatus.Offline:
        return 'red';
      case LocationOnlineStatus.AllOffline:
        return 'red';
      default:
        return '???????';
    }
  }

  icon() {
    switch (this.location.onlineStatus) {
      case LocationOnlineStatus.Unknown:
        return 'questionmark';
      case LocationOnlineStatus.AllOnline:
      case LocationOnlineStatus.Online:
        return 'online';
      case LocationOnlineStatus.MostlyOnline:
        return 'offlineCurrently';
      case LocationOnlineStatus.AllCurrentlyOffline:
      case LocationOnlineStatus.MostlyOffline:
      case LocationOnlineStatus.AllOffline:
      case LocationOnlineStatus.Offline:
        return 'offline';
      default:
        return 'question-circle';
    }
  }

  iconTooltip() {
    switch (this.location.onlineStatus) {
      case LocationOnlineStatus.Unknown:
        return '???';
      case LocationOnlineStatus.AllOnline:
        return this.translate.instant('lang.globals.online');
      case LocationOnlineStatus.Online:
        return this.translate.instant('lang.globals.online');
      case LocationOnlineStatus.MostlyOnline:
        return this.translate.instant('lang.globals.mixed');
      case LocationOnlineStatus.AllCurrentlyOffline:
        return this.translate.instant('lang.globals.mixed');
      case LocationOnlineStatus.MostlyOffline:
        return this.translate.instant('lang.globals.mixed');
      case LocationOnlineStatus.Offline:
        return this.translate.instant('lang.globals.offline');
      case LocationOnlineStatus.AllOffline:
        return this.translate.instant('lang.globals.offline');
      default:
        return '???????';
    }
  }

  private initFields() {
    this.tooltip = this.iconTooltip();
    this.faIcon = this.icon();
    this.color = this.iconColor();
    this.text = this.iconText();
  }
}
